export default __webpack_public_path__ + "41f0f3705aa596b0f6962ea9399ee6dd.png";